export interface YardFlexibleZoneFormProfile {
  id?: string
  name: string
  usageOptions?: string[]
}

export const defaultValues: YardFlexibleZoneFormProfile = {
  name: '',
}
